import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FormControl, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { addNewSensor, addSensor } from '../../features/fueladmin/fuelSlice';
import { CircularProgress } from '@mui/material';
import { sensorBrands, sensorKeys, sensorParamOptions } from '../../utils/fuelOptions';


const FuelAddSensorForm = ({ view, fuelSetup, assetId, sensorIndex }) => {

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [sensor, setSensor] = useState({});


    useEffect(() => {
        const { sensorBrand, sensorSerial, sensorParam, sensorMac, manufacturerSerial } = fuelSetup.sensors[sensorIndex - 1];
        setSensor({ assetId, setupId: fuelSetup.setupId, sensorIndex, sensorBrand, sensorSerial, sensorParam, sensorMac, manufacturerSerial });
    }, [fuelSetup, sensorIndex, view, assetId]);

    const updateSensor = (key, value) => {
        setSensor({ ...sensor, [key]: value });
    };

    const updateBrand = (value) => {
        setSensor({ ...sensor, sensorBrand: value });
    }

    const updateParam = (value) => {
        setSensor({ ...sensor, sensorParam: value });
    }

    const [formValid, setFormValid] = useState(false);


    useEffect(() => {
        let valid = true;
        sensorKeys.forEach(k => {
            if (!sensor.hasOwnProperty(k)) {
                valid = false;
            }
        })
        setFormValid(valid);
    }, [sensor])

    const saveSensor = () => {
        setLoading(true);
        if (view === 'addSensor') {
            dispatch(addNewSensor(sensor));
            dispatch(addSensor(sensor));
        } else if (view === 'editSensor') {
            setLoading(false);
        } else {
            setLoading(false);
        }

    };

    if (loading) {
        return (
            <div>
                <FormControl sx={{ m: 1, width: '100ch' }} >
                    <CircularProgress />
                </FormControl>
            </div>
        );
    } else {
        return (
            <div>
                <FormControl sx={{ m: 1, width: '100ch' }} >
                    <Typography variant="body1" display="inline">
                        <span><b>Sensor: {sensorIndex}</b></span>
                    </Typography>
                </FormControl>
                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <InputLabel id="vehicleType">Sensor Brand?</InputLabel>
                    <Select
                        variant="standard"
                        id="sensorBrand"
                        value={sensor.sensorBrand ?? ""}
                        onChange={(e) => updateBrand(e.target.value)}
                    >
                        {
                            sensorBrands.map(ev => <MenuItem key={ev} value={ev}>{ev}</MenuItem>)
                        }
                    </Select>
                </FormControl>

                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <TextField
                        label="Sensor Serial Number?"
                        id="sensorSerial"
                        value={sensor.sensorSerial ?? ""}
                        onChange={(e) => updateSensor(e.target.id, e.target.value)}
                        sx={{ m: 1, width: '30ch' }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">Serial: </InputAdornment>,
                        }}
                        variant="standard"
                    />
                </FormControl>

                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <InputLabel id="vehicleType">Sensor Parameter?</InputLabel>
                    <Select
                        variant="standard"
                        id="sensorParam"
                        value={sensor.sensorParam ?? ""}
                        onChange={(e) => updateParam(e.target.value)}
                    >
                        {
                            sensorParamOptions.map(ev => <MenuItem key={ev} value={ev}>{ev}</MenuItem>)
                        }
                    </Select>
                </FormControl>
                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <TextField
                        label="Sensor MAC Address?"
                        id="sensorMac"
                        value={sensor.sensorMac ?? ""}
                        onChange={(e) => updateSensor(e.target.id, e.target.value)}
                        sx={{ m: 1, width: '30ch' }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">Mac: </InputAdornment>,
                        }}
                        variant="standard"
                    />
                </FormControl>


                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <TextField
                        label="Manufacturer Serial?"
                        id="manufacturerSerial"
                        value={sensor.manufacturerSerial ?? ""}
                        onChange={(e) => updateSensor(e.target.id, e.target.value)}
                        sx={{ m: 1, width: '30ch' }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">Serial: </InputAdornment>,
                        }}
                        variant="standard"
                    />
                </FormControl>


                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <Button onClick={() => saveSensor()} disabled={!formValid}>
                        Save Sensor
                    </Button>
                </FormControl>
            </div>
        )
    }

}

export default FuelAddSensorForm;